tinymce.addI18n("ja", {
    "#": "#",
    "Accessibility": "\u30a2\u30af\u30bb\u30b7\u30d3\u30ea\u30c6\u30a3",
    "Accordion": "\u30a2\u30b3\u30fc\u30c7\u30a3\u30aa\u30f3",
    "Accordion body...": "\u30a2\u30b3\u30fc\u30c7\u30a3\u30aa\u30f3\u306e\u672c\u6587...",
    "Accordion summary...": "\u30a2\u30b3\u30fc\u30c7\u30a3\u30aa\u30f3\u306e\u6982\u8981...",
    "Action": "\u30a2\u30af\u30b7\u30e7\u30f3",
    "Activity": "\u884c\u52d5",
    "Address": "\u30a2\u30c9\u30ec\u30b9",
    "Advanced": "\u8a73\u7d30",
    "Align": "\u914d\u7f6e",
    "Align center": "\u4e2d\u592e\u63c3\u3048",
    "Align left": "\u5de6\u63c3\u3048",
    "Align right": "\u53f3\u63c3\u3048",
    "Alignment": "\u914d\u7f6e",
    "Alignment {0}": "\u6574\u5217 {0}",
    "All": "\u3059\u3079\u3066",
    "Alternative description": "\u4ee3\u66ff\u306e\u8aac\u660e\u6587",
    "Alternative source": "\u4ee3\u66ff\u30bd\u30fc\u30b9",
    "Alternative source URL": "\u4ee3\u66ff\u30bd\u30fc\u30b9URL",
    "Anchor": "\u30a2\u30f3\u30ab\u30fc",
    "Anchor...": "\u30a2\u30f3\u30ab\u30fc...",
    "Anchors": "\u30a2\u30f3\u30ab\u30fc",
    "Animals and Nature": "\u52d5\u7269\u3068\u81ea\u7136",
    "Arrows": "\u77e2\u5370",
    "B": "\u9752",
    "Background color": "\u80cc\u666f\u8272",
    "Background color {0}": "\u80cc\u666f\u8272 {0}",
    "Black": "\u30d6\u30e9\u30c3\u30af",
    "Block": "\u30d6\u30ed\u30c3\u30af",
    "Block {0}": "\u30d6\u30ed\u30c3\u30af {0}",
    "Blockquote": "\u5f15\u7528",
    "Blocks": "\u30d6\u30ed\u30c3\u30af",
    "Blue": "\u30d6\u30eb\u30fc",
    "Blue component": "\u9752\u8272\u30b3\u30f3\u30dd\u30fc\u30cd\u30f3\u30c8",
    "Body": "\u672c\u6587",
    "Bold": "\u592a\u5b57",
    "Border": "\u30dc\u30fc\u30c0\u30fc",
    "Border color": "\u30dc\u30fc\u30c0\u30fc\u306e\u8272",
    "Border style": "\u67a0\u7dda\u30b9\u30bf\u30a4\u30eb",
    "Border width": "\u67a0\u7dda\u5e45",
    "Bottom": "\u4e0b\u63c3\u3048",
    "Browse files": "\u30d5\u30a1\u30a4\u30eb\u3092\u30d6\u30e9\u30a6\u30ba",
    "Browse for an image": "\u753b\u50cf\u3092\u53c2\u7167",
    "Browse links": "\u30ea\u30f3\u30af\u3092\u30d6\u30e9\u30a6\u30ba",
    "Bullet list": "\u7b87\u6761\u66f8\u304d",
    "Cancel": "\u53d6\u6d88",
    "Caption": "\u30ad\u30e3\u30d7\u30b7\u30e7\u30f3",
    "Cell": "\u30bb\u30eb",
    "Cell padding": "\u30bb\u30eb\u5185\u306e\u30b9\u30da\u30fc\u30b9",
    "Cell properties": "\u30bb\u30eb\u306e\u30d7\u30ed\u30d1\u30c6\u30a3",
    "Cell spacing": "\u30bb\u30eb\u306e\u9593\u9694",
    "Cell styles": "\u30bb\u30eb\u306e\u7a2e\u985e",
    "Cell type": "\u30bb\u30eb\u306e\u7a2e\u985e",
    "Center": "\u4e2d\u592e\u63c3\u3048",
    "Characters": "\u6587\u5b57\u6570",
    "Characters (no spaces)": "\u6587\u5b57\u6570 (\u30b9\u30da\u30fc\u30b9\u306a\u3057)",
    "Circle": "\u4e38",
    "Class": "\u30af\u30e9\u30b9",
    "Clear formatting": "\u66f8\u5f0f\u3092\u30af\u30ea\u30a2",
    "Close": "\u9589\u3058\u308b",
    "Code": "\u30b3\u30fc\u30c9",
    "Code sample...": "\u30b3\u30fc\u30c9\u306e\u30b5\u30f3\u30d7\u30eb...",
    "Code view": "\u30b3\u30fc\u30c9\u8868\u793a",
    "Color Picker": "\u30ab\u30e9\u30fc\u30d4\u30c3\u30ab\u30fc",
    "Color swatch": "\u8272\u306e\u898b\u672c",
    "Cols": "\u5217\u6570",
    "Column": "\u5217",
    "Column clipboard actions": "\u5217\u306e\u30af\u30ea\u30c3\u30d7\u30dc\u30fc\u30c9\u30a2\u30af\u30b7\u30e7\u30f3",
    "Column group": "\u5217\u30b0\u30eb\u30fc\u30d7",
    "Column header": "\u5217\u306e\u30d8\u30c3\u30c0\u30fc",
    "Constrain proportions": "\u7e26\u6a2a\u6bd4\u3092\u56fa\u5b9a",
    "Copy": "\u30b3\u30d4\u30fc",
    "Copy column": "\u5217\u3092\u30b3\u30d4\u30fc",
    "Copy row": "\u884c\u306e\u30b3\u30d4\u30fc",
    "Could not find the specified string.": "\u304a\u63a2\u3057\u306e\u6587\u5b57\u5217\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f\u3002",
    "Could not load emojis": "\u7d75\u6587\u5b57\u304c\u8aad\u307f\u8fbc\u3081\u307e\u305b\u3093\u3067\u3057\u305f",
    "Count": "\u30ab\u30a6\u30f3\u30c8",
    "Currency": "\u901a\u8ca8",
    "Current window": "\u540c\u3058\u30a6\u30a3\u30f3\u30c9\u30a6",
    "Custom color": "\u30e6\u30fc\u30b6\u30fc\u8a2d\u5b9a\u306e\u8272",
    "Custom...": "\u30e6\u30fc\u30b6\u30fc\u8a2d\u5b9a...",
    "Cut": "\u5207\u308a\u53d6\u308a",
    "Cut column": "\u5217\u3092\u30ab\u30c3\u30c8",
    "Cut row": "\u884c\u306e\u5207\u308a\u53d6\u308a",
    "Dark Blue": "\u30c0\u30fc\u30af\u30d6\u30eb\u30fc",
    "Dark Gray": "\u30c0\u30fc\u30af\u30b0\u30ec\u30fc",
    "Dark Green": "\u30c0\u30fc\u30af\u30b0\u30ea\u30fc\u30f3",
    "Dark Orange": "\u30c0\u30fc\u30af\u30aa\u30ec\u30f3\u30b8",
    "Dark Purple": "\u30c0\u30fc\u30af\u30d1\u30fc\u30d7\u30eb",
    "Dark Red": "\u30c0\u30fc\u30af\u30ec\u30c3\u30c9",
    "Dark Turquoise": "\u30c0\u30fc\u30af\u30bf\u30fc\u30b3\u30a4\u30ba",
    "Dark Yellow": "\u30c0\u30fc\u30af\u30a4\u30a8\u30ed\u30fc",
    "Dashed": "\u7834\u7dda",
    "Date/time": "\u65e5\u4ed8/\u6642\u523b",
    "Decrease indent": "\u30a4\u30f3\u30c7\u30f3\u30c8\u3092\u6e1b\u3089\u3059",
    "Default": "\u65e2\u5b9a",
    "Delete accordion": "\u30a2\u30b3\u30fc\u30c7\u30a3\u30aa\u30f3\u306e\u524a\u9664",
    "Delete column": "\u5217\u306e\u524a\u9664",
    "Delete row": "\u884c\u306e\u524a\u9664",
    "Delete table": "\u30c6\u30fc\u30d6\u30eb\u306e\u524a\u9664",
    "Dimensions": "\u30b5\u30a4\u30ba",
    "Disc": "\u9ed2\u4e38",
    "Div": "\u5206\u5272",
    "Document": "\u30c9\u30ad\u30e5\u30e1\u30f3\u30c8",
    "Dotted": "\u70b9\u7dda",
    "Double": "\u4e8c\u91cd\u7dda",
    "Drop an image here": "\u3053\u3053\u306b\u753b\u50cf\u3092\u30c9\u30ed\u30c3\u30d7",
    "Dropped file type is not supported": "\u30c9\u30ed\u30c3\u30d7\u3055\u308c\u305f\u30d5\u30a1\u30a4\u30eb\u30bf\u30a4\u30d7\u306f\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u307e\u305b\u3093",
    "Edit": "\u7de8\u96c6",
    "Embed": "\u57cb\u3081\u8fbc\u307f",
    "Emojis": "\u7d75\u6587\u5b57",
    "Emojis...": "\u7d75\u6587\u5b57...",
    "Error": "\u30a8\u30e9\u30fc",
    "Error: Form submit field collision.": "\u30a8\u30e9\u30fc\uff1a\u30d5\u30a9\u30fc\u30e0\u9001\u4fe1\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7af6\u5408\u3057\u3066\u3044\u307e\u3059\u3002",
    "Error: No form element found.": "\u30a8\u30e9\u30fc\uff1a\u30d5\u30a9\u30fc\u30e0\u8981\u7d20\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f\u3002",
    "Extended Latin": "\u30e9\u30c6\u30f3\u6587\u5b57\u62e1\u5f35",
    "Failed to initialize plugin: {0}": "\u30d7\u30e9\u30b0\u30a4\u30f3{0}\u306e\u521d\u671f\u5316\u306b\u5931\u6557\u3057\u307e\u3057\u305f",
    "Failed to load plugin url: {0}": "\u30d7\u30e9\u30b0\u30a4\u30f3\u306eURL{0}\u3092\u8aad\u307f\u8fbc\u3081\u307e\u305b\u3093\u3067\u3057\u305f",
    "Failed to load plugin: {0} from url {1}": "URL{1}\u304b\u3089\u306e\u30d7\u30e9\u30b0\u30a4\u30f3{0}\u306e\u8aad\u307f\u8fbc\u307f\u306b\u5931\u6557\u3057\u307e\u3057\u305f",
    "Failed to upload image: {0}": "\u753b\u50cf{0}\u3092\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f",
    "File": "\u30d5\u30a1\u30a4\u30eb",
    "Find": "\u691c\u7d22...",
    "Find (if searchreplace plugin activated)": "\u691c\u7d22 (\u7f6e\u63db\u30d7\u30e9\u30b0\u30a4\u30f3\u6709\u52b9\u6642)",
    "Find and Replace": "\u691c\u7d22\u3068\u7f6e\u63db",
    "Find and replace...": "\u7f6e\u63db...",
    "Find in selection": "\u9078\u629e\u90e8\u5206\u3067\u691c\u7d22",
    "Find whole words only": "\u8a9e\u5168\u4f53\u3092\u542b\u3080\u3082\u306e\u306e\u307f\u691c\u7d22",
    "Flags": "\u65d7",
    "Focus to contextual toolbar": "\u30b3\u30f3\u30c6\u30ad\u30b9\u30c8\u30c4\u30fc\u30eb\u30d0\u30fc\u306b\u30d5\u30a9\u30fc\u30ab\u30b9",
    "Focus to element path": "\u8981\u7d20\u30d1\u30b9\u306b\u30d5\u30a9\u30fc\u30ab\u30b9",
    "Focus to menubar": "\u30e1\u30cb\u30e5\u30fc\u30d0\u30fc\u306b\u30d5\u30a9\u30fc\u30ab\u30b9",
    "Focus to toolbar": "\u30c4\u30fc\u30eb\u30d0\u30fc\u306b\u30d5\u30a9\u30fc\u30ab\u30b9",
    "Font": "\u30d5\u30a9\u30f3\u30c8",
    "Font size {0}": "\u30d5\u30a9\u30f3\u30c8\u30b5\u30a4\u30ba {0}",
    "Font sizes": "\u30d5\u30a9\u30f3\u30c8\u306e\u30b5\u30a4\u30ba",
    "Font {0}": "\u30d5\u30a9\u30f3\u30c8 {0}",
    "Fonts": "\u30d5\u30a9\u30f3\u30c8",
    "Food and Drink": "\u98df\u3079\u7269\u3068\u98f2\u307f\u7269",
    "Footer": "\u30d5\u30c3\u30bf\u30fc",
    "Format": "\u66f8\u5f0f\u8a2d\u5b9a",
    "Format {0}": "\u30d5\u30a9\u30fc\u30de\u30c3\u30c8 {0}",
    "Formats": "\u66f8\u5f0f",
    "Fullscreen": "\u30d5\u30eb\u30b9\u30af\u30ea\u30fc\u30f3",
    "G": "\u7dd1",
    "General": "\u4e00\u822c",
    "Gray": "\u30b0\u30ec\u30fc",
    "Green": "\u30b0\u30ea\u30fc\u30f3",
    "Green component": "\u7dd1\u8272\u30b3\u30f3\u30dd\u30fc\u30cd\u30f3\u30c8",
    "Groove": "\u8c37\u7dda",
    "Handy Shortcuts": "\u4fbf\u5229\u306a\u30b7\u30e7\u30fc\u30c8\u30ab\u30c3\u30c8",
    "Header": "\u30d8\u30c3\u30c0\u30fc",
    "Header cell": "\u30d8\u30c3\u30c0\u30fc\u30bb\u30eb",
    "Heading 1": "\u898b\u51fa\u30571",
    "Heading 2": "\u898b\u51fa\u30572",
    "Heading 3": "\u898b\u51fa\u30573",
    "Heading 4": "\u898b\u51fa\u30574",
    "Heading 5": "\u898b\u51fa\u30575",
    "Heading 6": "\u898b\u51fa\u30576",
    "Headings": "\u898b\u51fa\u3057",
    "Height": "\u9ad8\u3055",
    "Help": "\u30d8\u30eb\u30d7",
    "Hex color code": "16\u9032\u30ab\u30e9\u30fc\u30b3\u30fc\u30c9",
    "Hidden": "\u975e\u8868\u793a",
    "Horizontal align": "\u6c34\u5e73\u306b\u6574\u5217",
    "Horizontal line": "\u6c34\u5e73\u7f6b\u7dda",
    "Horizontal space": "\u5de6\u53f3\u4f59\u767d",
    "ID": "ID",
    "ID should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.": "ID\u306f\u6587\u5b57\u3067\u59cb\u307e\u308a\u3001\u305d\u306e\u5f8c\u306b\u6587\u5b57\u3001\u6570\u5b57\u3001\u30c0\u30c3\u30b7\u30e5\u3001\u30d4\u30ea\u30aa\u30c9\u3001\u30b3\u30ed\u30f3\u3001\u307e\u305f\u306f\u30a2\u30f3\u30c0\u30fc\u30b9\u30b3\u30a2\u304c\u7d9a\u304f\u5fc5\u8981\u304c\u3042\u308a\u307e\u3059\u3002",
    "Image is decorative": "\u753b\u50cf\u306f\u88c5\u98fe\u753b\u50cf",
    "Image list": "\u753b\u50cf\u30ea\u30b9\u30c8",
    "Image title": "\u753b\u50cf\u30bf\u30a4\u30c8\u30eb",
    "Image...": "\u753b\u50cf..",
    "ImageProxy HTTP error: Could not find Image Proxy": "\u753b\u50cf\u30d7\u30ed\u30ad\u30b7 HTTP\u30a8\u30e9\u30fc\uff1a\u753b\u50cf\u30d7\u30ed\u30ad\u30b7\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f",
    "ImageProxy HTTP error: Incorrect Image Proxy URL": "\u753b\u50cf\u30d7\u30ed\u30ad\u30b7 HTTP\u30a8\u30e9\u30fc\uff1a\u4e0d\u6b63\u306a\u753b\u50cf\u30d7\u30ed\u30ad\u30b7URL",
    "ImageProxy HTTP error: Rejected request": "\u753b\u50cf\u30d7\u30ed\u30ad\u30b7 HTTP\u30a8\u30e9\u30fc\uff1a\u62d2\u5426\u3055\u308c\u305f\u30ea\u30af\u30a8\u30b9\u30c8",
    "ImageProxy HTTP error: Unknown ImageProxy error": "\u753b\u50cf\u30d7\u30ed\u30ad\u30b7 HTTP\u30a8\u30e9\u30fc\uff1a\u4e0d\u660e\u306a\u753b\u50cf\u30d7\u30ed\u30ad\u30b7\u30a8\u30e9\u30fc",
    "Increase indent": "\u30a4\u30f3\u30c7\u30f3\u30c8\u3092\u5897\u3084\u3059",
    "Inline": "\u30a4\u30f3\u30e9\u30a4\u30f3",
    "Insert": "\u633f\u5165",
    "Insert Template": "\u30c6\u30f3\u30d7\u30ec\u30fc\u30c8\u306e\u633f\u5165..",
    "Insert accordion": "\u30a2\u30b3\u30fc\u30c7\u30a3\u30aa\u30f3\u306e\u633f\u5165",
    "Insert column after": "\u5f8c\u306b\u5217\u3092\u633f\u5165",
    "Insert column before": "\u524d\u306b\u5217\u3092\u633f\u5165",
    "Insert date/time": "\u65e5\u4ed8/\u6642\u523b\u306e\u633f\u5165",
    "Insert image": "\u753b\u50cf\u306e\u633f\u5165",
    "Insert link (if link plugin activated)": "\u30ea\u30f3\u30af\u3092\u633f\u5165 (\u30ea\u30f3\u30af\u30d7\u30e9\u30b0\u30a4\u30f3\u6709\u52b9\u6642)",
    "Insert row after": "\u5f8c\u306b\u884c\u3092\u633f\u5165",
    "Insert row before": "\u524d\u306b\u884c\u3092\u633f\u5165",
    "Insert table": "\u8868\u306e\u633f\u5165",
    "Insert template...": "\u30c6\u30f3\u30d7\u30ec\u30fc\u30c8\u306e\u633f\u5165..",
    "Insert video": "\u52d5\u753b\u306e\u633f\u5165",
    "Insert/Edit code sample": "\u30b3\u30fc\u30c9\u30b5\u30f3\u30d7\u30eb\u306e\u633f\u5165/\u7de8\u96c6",
    "Insert/edit image": "\u753b\u50cf\u306e\u633f\u5165/\u7de8\u96c6",
    "Insert/edit link": "\u30ea\u30f3\u30af\u306e\u633f\u5165/\u7de8\u96c6",
    "Insert/edit media": "\u30e1\u30c7\u30a3\u30a2\u306e\u633f\u5165/\u7de8\u96c6",
    "Insert/edit video": "\u52d5\u753b\u306e\u633f\u5165/\u7de8\u96c6",
    "Inset": "\u5185\u7dda",
    "Invalid hex color code: {0}": "\u7121\u52b9\u306a16\u9032\u30ab\u30e9\u30fc\u30b3\u30fc\u30c9: {0}",
    "Invalid input": "\u7121\u52b9\u306a\u5165\u529b",
    "Italic": "\u659c\u4f53",
    "Justify": "\u4e21\u7aef\u63c3\u3048",
    "Keyboard Navigation": "\u30ad\u30fc\u30dc\u30fc\u30c9\u30ca\u30d3\u30b2\u30fc\u30b7\u30e7\u30f3",
    "Language": "\u8a00\u8a9e",
    "Learn more...": "\u8a73\u7d30...",
    "Left": "\u5de6\u63c3\u3048",
    "Left to right": "\u5de6\u304b\u3089\u53f3",
    "Light Blue": "\u30e9\u30a4\u30c8\u30d6\u30eb\u30fc",
    "Light Gray": "\u30e9\u30a4\u30c8\u30b0\u30ec\u30fc",
    "Light Green": "\u30e9\u30a4\u30c8\u30b0\u30ea\u30fc\u30f3",
    "Light Purple": "\u30e9\u30a4\u30c8\u30d1\u30fc\u30d7\u30eb",
    "Light Red": "\u30e9\u30a4\u30c8\u30ec\u30c3\u30c9",
    "Light Yellow": "\u30e9\u30a4\u30c8\u30a4\u30a8\u30ed\u30fc",
    "Line height": "\u884c\u306e\u9ad8\u3055",
    "Link list": "\u30ea\u30f3\u30af\u306e\u4e00\u89a7",
    "Link...": "\u30ea\u30f3\u30af...",
    "List Properties": "\u7b87\u6761\u66f8\u304d\u306e\u30d7\u30ed\u30d1\u30c6\u30a3",
    "List properties...": "\u7b87\u6761\u66f8\u304d\u306e\u30d7\u30ed\u30d1\u30c6\u30a3...",
    "Loading emojis...": "\u7d75\u6587\u5b57\u3092\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059\u2026",
    "Loading...": "\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059...",
    "Lower Alpha": "\u5c0f\u6587\u5b57\u30a2\u30eb\u30d5\u30a1\u30d9\u30c3\u30c8",
    "Lower Greek": "\u5c0f\u6587\u5b57\u30ae\u30ea\u30b7\u30e3\u6587\u5b57",
    "Lower Roman": "\u5c0f\u6587\u5b57\u30ed\u30fc\u30de\u5b57",
    "Match case": "\u5927\u6587\u5b57\u3068\u5c0f\u6587\u5b57\u3092\u533a\u5225",
    "Mathematical": "\u6570\u5b66\u8a18\u53f7",
    "Media poster (Image URL)": "\u30e1\u30c7\u30a3\u30a2\u30dd\u30b9\u30bf\u30fc (\u753b\u50cfURL)",
    "Media...": "\u30e1\u30c7\u30a3\u30a2\u2026",
    "Medium Blue": "\u30e1\u30c7\u30a3\u30a2\u30e0\u30d6\u30eb\u30fc",
    "Medium Gray": "\u30df\u30c7\u30a3\u30a2\u30e0\u30b0\u30ec\u30fc",
    "Medium Purple": "\u30df\u30c7\u30a3\u30a2\u30e0\u30d1\u30fc\u30d7\u30eb",
    "Merge cells": "\u30bb\u30eb\u306e\u7d50\u5408",
    "Middle": "\u4e2d\u592e\u63c3\u3048",
    "Midnight Blue": "\u30df\u30c3\u30c9\u30ca\u30a4\u30c8\u30d6\u30eb\u30fc",
    "More...": "\u8a73\u7d30...",
    "Name": "\u540d\u524d",
    "Navy Blue": "\u30cd\u30a4\u30d3\u30fc",
    "New document": "\u65b0\u898f\u30c9\u30ad\u30e5\u30e1\u30f3\u30c8",
    "New window": "\u65b0\u898f\u30a6\u30a3\u30f3\u30c9\u30a6",
    "Next": "\u6b21\u3078",
    "No": "\u3044\u3044\u3048",
    "No alignment": "\u914d\u7f6e\u306a\u3057",
    "No color": "\u8272\u306a\u3057",
    "Nonbreaking space": "\u56fa\u5b9a\u30b9\u30da\u30fc\u30b9",
    "None": "\u306a\u3057",
    "Numbered list": "\u756a\u53f7\u4ed8\u304d\u7b87\u6761\u66f8\u304d",
    "OR": "\u307e\u305f\u306f",
    "Objects": "\u7269",
    "Ok": "OK",
    "Open help dialog": "\u30d8\u30eb\u30d7\u30c0\u30a4\u30a2\u30ed\u30b0\u3092\u958b\u304f",
    "Open link": "\u30ea\u30f3\u30af\u3092\u958b\u304f",
    "Open link in...": "\u30ea\u30f3\u30af\u306e\u958b\u304d\u65b9...",
    "Open popup menu for split buttons": "\u5206\u5272\u30dc\u30bf\u30f3\u306e\u30dd\u30c3\u30d7\u30a2\u30c3\u30d7\u30e1\u30cb\u30e5\u30fc\u3092\u958b\u304f",
    "Orange": "\u30aa\u30ec\u30f3\u30b8",
    "Outset": "\u5916\u7dda",
    "Page break": "\u30da\u30fc\u30b8\u533a\u5207\u308a",
    "Paragraph": "\u6bb5\u843d",
    "Paste": "\u8cbc\u308a\u4ed8\u3051",
    "Paste as text": "\u30c6\u30ad\u30b9\u30c8\u3068\u3057\u3066\u8cbc\u308a\u4ed8\u3051",
    "Paste column after": "\u5f8c\u306b\u5217\u3092\u8cbc\u308a\u4ed8\u3051",
    "Paste column before": "\u524d\u306b\u5217\u3092\u8cbc\u308a\u4ed8\u3051",
    "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.": "\u8cbc\u308a\u4ed8\u3051\u306f\u73fe\u5728\u30d7\u30ec\u30fc\u30f3\u30c6\u30ad\u30b9\u30c8\u30e2\u30fc\u30c9\u3067\u3059\u3002\u3053\u306e\u30aa\u30d7\u30b7\u30e7\u30f3\u3092\u30aa\u30d5\u306b\u3057\u306a\u3044\u9650\u308a\u5185\u5bb9\u306f\u30d7\u30ec\u30fc\u30f3\u30c6\u30ad\u30b9\u30c8\u3068\u3057\u3066\u8cbc\u308a\u4ed8\u3051\u3089\u308c\u307e\u3059\u3002",
    "Paste or type a link": "\u30ea\u30f3\u30af\u3092\u30da\u30fc\u30b9\u30c8\u307e\u305f\u306f\u5165\u529b",
    "Paste row after": "\u4e0b\u5074\u306b\u884c\u3092\u8cbc\u308a\u4ed8\u3051",
    "Paste row before": "\u4e0a\u5074\u306b\u884c\u3092\u8cbc\u308a\u4ed8\u3051",
    "Paste your embed code below:": "\u57cb\u3081\u8fbc\u307f\u7528\u30b3\u30fc\u30c9\u3092\u4ee5\u4e0b\u306b\u8cbc\u308a\u4ed8\u3051\u3066\u304f\u3060\u3055\u3044\u3002",
    "People": "\u4eba",
    "Plugins": "\u30d7\u30e9\u30b0\u30a4\u30f3",
    "Plugins installed ({0}):": "\u30a4\u30f3\u30b9\u30c8\u30fc\u30eb\u6e08\u30d7\u30e9\u30b0\u30a4\u30f3 ({0})\uff1a",
    "Powered by {0}": "{0} \u306b\u3088\u3063\u3066\u642d\u8f09\u3055\u308c\u305f",
    "Pre": "\u6574\u5f62\u6e08\u307f\u30c6\u30ad\u30b9\u30c8",
    "Preferences": "\u30d7\u30ea\u30d5\u30a1\u30ec\u30f3\u30b9",
    "Preformatted": "\u66f8\u5f0f\u8a2d\u5b9a\u6e08\u307f",
    "Premium plugins:": "\u30d7\u30ec\u30df\u30a2\u30e0\u30d7\u30e9\u30b0\u30a4\u30f3\uff1a",
    "Press the Up and Down arrow keys to resize the editor.": "\u4e0a\u77e2\u5370\u3068\u4e0b\u77e2\u5370\u306e\u30ad\u30fc\u3092\u62bc\u3057\u3066\u30a8\u30c7\u30a3\u30bf\u30fc\u306e\u30b5\u30a4\u30ba\u3092\u5909\u66f4\u3057\u307e\u3059\u3002",
    "Press the arrow keys to resize the editor.": "\u77e2\u5370\u30ad\u30fc\u3092\u62bc\u3057\u3066\u30a8\u30c7\u30a3\u30bf\u30fc\u306e\u30b5\u30a4\u30ba\u3092\u5909\u66f4\u3057\u307e\u3059\u3002",
    "Press {0} for help": "\u30d8\u30eb\u30d7\u3092\u898b\u308b\u306b\u306f {0} \u3092\u62bc\u3057\u307e\u3059",
    "Preview": "\u30d7\u30ec\u30d3\u30e5\u30fc",
    "Previous": "\u524d\u3078",
    "Print": "\u5370\u5237",
    "Print...": "\u5370\u5237...",
    "Purple": "\u30d1\u30fc\u30d7\u30eb",
    "Quotations": "\u5f15\u7528",
    "R": "\u8d64",
    "Range 0 to 255": "\u7bc4\u56f20\u301c255",
    "Red": "\u30ec\u30c3\u30c9",
    "Red component": "\u8d64\u8272\u30b3\u30f3\u30dd\u30fc\u30cd\u30f3\u30c8",
    "Redo": "\u3084\u308a\u76f4\u3057",
    "Remove": "\u524a\u9664",
    "Remove color": "\u8272\u8a2d\u5b9a\u3092\u89e3\u9664",
    "Remove link": "\u30ea\u30f3\u30af\u306e\u524a\u9664",
    "Replace": "\u7f6e\u63db",
    "Replace all": "\u3059\u3079\u3066\u7f6e\u63db",
    "Replace with": "\u7f6e\u63db\u5f8c\u306e\u6587\u5b57\u5217",
    "Resize": "\u30b5\u30a4\u30ba\u5909\u66f4",
    "Restore last draft": "\u524d\u56de\u306e\u4e0b\u66f8\u304d\u3092\u56de\u5fa9",
    "Reveal or hide additional toolbar items": "\u8ffd\u52a0\u306e\u30c4\u30fc\u30eb \u30d0\u30fc \u30a2\u30a4\u30c6\u30e0\u306e\u8868\u793a\u307e\u305f\u306f\u975e\u8868\u793a",
    "Rich Text Area": "\u30ea\u30c3\u30c1\u30c6\u30ad\u30b9\u30c8\u30a8\u30ea\u30a2",
    "Rich Text Area. Press ALT-0 for help.": "\u30ea\u30c3\u30c1\u30c6\u30ad\u30b9\u30c8\u30a8\u30ea\u30a2\u3002Alt-0\u3067\u30d8\u30eb\u30d7\u304c\u8868\u793a\u3055\u308c\u307e\u3059\u3002",
    "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help": "\u30ea\u30c3\u30c1\u30c6\u30ad\u30b9\u30c8\u30a8\u30ea\u30a2\u3002ALT-F9\u3067\u30e1\u30cb\u30e5\u30fc\u3001ALT-F10\u3067\u30c4\u30fc\u30eb\u30d0\u30fc\u3001ALT-0\u3067\u30d8\u30eb\u30d7\u304c\u8868\u793a\u3055\u308c\u307e\u3059\u3002",
    "Ridge": "\u5c71\u7dda",
    "Right": "\u53f3\u63c3\u3048",
    "Right to left": "\u53f3\u304b\u3089\u5de6",
    "Row": "\u884c",
    "Row clipboard actions": "\u884c\u306e\u30af\u30ea\u30c3\u30d7\u30dc\u30fc\u30c9\u30a2\u30af\u30b7\u30e7\u30f3",
    "Row group": "\u884c\u30b0\u30eb\u30fc\u30d7",
    "Row header": "\u884c\u306e\u30d8\u30c3\u30c0\u30fc",
    "Row properties": "\u884c\u306e\u30d7\u30ed\u30d1\u30c6\u30a3",
    "Row type": "\u884c\u30bf\u30a4\u30d7",
    "Rows": "\u884c\u6570",
    "Save": "\u4fdd\u5b58",
    "Save (if save plugin activated)": "\u4fdd\u5b58 (\u4fdd\u5b58\u30d7\u30e9\u30b0\u30a4\u30f3\u6709\u52b9\u6642)",
    "Scope": "\u30b9\u30b3\u30fc\u30d7",
    "Search": "\u691c\u7d22",
    "Select all": "\u3059\u3079\u3066\u9078\u629e",
    "Select...": "\u9078\u629e...",
    "Selection": "\u9078\u629e",
    "Shortcut": "\u30b7\u30e7\u30fc\u30c8\u30ab\u30c3\u30c8",
    "Show blocks": "\u6587\u7ae0\u306e\u533a\u5207\u308a\u3092\u70b9\u7dda\u3067\u8868\u793a",
    "Show caption": "\u30ad\u30e3\u30d7\u30b7\u30e7\u30f3\u306e\u8868\u793a",
    "Show invisible characters": "\u975e\u8868\u793a\u6587\u5b57\u3092\u8868\u793a",
    "Size": "\u30b5\u30a4\u30ba",
    "Solid": "\u5b9f\u7dda",
    "Source": "\u30bd\u30fc\u30b9",
    "Source code": "\u30bd\u30fc\u30b9\u30b3\u30fc\u30c9",
    "Special Character": "\u7279\u6b8a\u6587\u5b57",
    "Special character...": "\u7279\u6b8a\u6587\u5b57...",
    "Split cell": "\u30bb\u30eb\u306e\u5206\u5272",
    "Square": "\u56db\u89d2",
    "Start list at number": "\u756a\u53f7\u30ea\u30b9\u30c8\u306e\u958b\u59cb",
    "Strikethrough": "\u53d6\u6d88\u7dda",
    "Style": "\u30b9\u30bf\u30a4\u30eb",
    "Subscript": "\u4e0b\u4ed8\u304d",
    "Superscript": "\u4e0a\u4ed8\u304d",
    "Switch to or from fullscreen mode": "\u30d5\u30eb\u30b9\u30af\u30ea\u30fc\u30f3\u30e2\u30fc\u30c9\u5207\u66ff",
    "Symbols": "\u8a18\u53f7",
    "System Font": "\u30b7\u30b9\u30c6\u30e0\u30d5\u30a9\u30f3\u30c8",
    "Table": "\u8868",
    "Table caption": "\u30c6\u30fc\u30d6\u30eb\u306e\u898b\u51fa\u3057",
    "Table properties": "\u30c6\u30fc\u30d6\u30eb\u306e\u30d7\u30ed\u30d1\u30c6\u30a3",
    "Table styles": "\u30c6\u30fc\u30d6\u30eb\u306e\u7a2e\u985e",
    "Template": "\u30c6\u30f3\u30d7\u30ec\u30fc\u30c8",
    "Templates": "\u30c6\u30f3\u30d7\u30ec\u30fc\u30c8",
    "Text": "\u30c6\u30ad\u30b9\u30c8",
    "Text color": "\u30c6\u30ad\u30b9\u30c8\u8272",
    "Text color {0}": "\u30c6\u30ad\u30b9\u30c8\u8272 {0}",
    "Text to display": "\u8868\u793a\u3059\u308b\u30c6\u30ad\u30b9\u30c8",
    "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?": "\u5165\u529b\u3055\u308c\u305fURL\u306f\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u306e\u3088\u3046\u3067\u3059\u3002\u300cmailto:\u300d\u30d7\u30ec\u30d5\u30a3\u30c3\u30af\u30b9\u3092\u8ffd\u52a0\u3057\u307e\u3059\u304b\uff1f",
    "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?": "\u5165\u529b\u3055\u308c\u305fURL\u306f\u5916\u90e8\u30ea\u30f3\u30af\u306e\u3088\u3046\u3067\u3059\u3002\u300chttp://\u300d\u30d7\u30ec\u30d5\u30a3\u30c3\u30af\u30b9\u3092\u8ffd\u52a0\u3057\u307e\u3059\u304b\uff1f",
    "The URL you entered seems to be an external link. Do you want to add the required https:// prefix?": "\u5165\u529b\u3055\u308c\u305fURL\u306f\u5916\u90e8\u30ea\u30f3\u30af\u306e\u3088\u3046\u3067\u3059\u3002\u5fc5\u8981\u306a\u300chttps://\u300d\u30d7\u30ec\u30d5\u30a3\u30c3\u30af\u30b9\u3092\u8ffd\u52a0\u3057\u307e\u3059\u304b\uff1f",
    "Title": "\u30bf\u30a4\u30c8\u30eb",
    "To open the popup, press Shift+Enter": "\u30dd\u30c3\u30d7\u30a2\u30c3\u30d7\u3092\u958b\u304f\u306b\u306f\u3001Shift+Enter\u3092\u62bc\u3057\u3066\u304f\u3060\u3055\u3044",
    "Toggle accordion": "\u30a2\u30b3\u30fc\u30c7\u30a3\u30aa\u30f3\u306e\u5207\u308a\u66ff\u3048",
    "Tools": "\u30c4\u30fc\u30eb",
    "Top": "\u4e0a\u63c3\u3048",
    "Travel and Places": "\u65c5\u884c\u3068\u5834\u6240",
    "Turquoise": "\u30bf\u30fc\u30b3\u30a4\u30ba",
    "Underline": "\u4e0b\u7dda",
    "Undo": "\u5143\u306b\u623b\u3059",
    "Upload": "\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9",
    "Uploading image": "\u753b\u50cf\u30a2\u30c3\u30d7\u30ed\u30fc\u30c9\u4e2d",
    "Upper Alpha": "\u5927\u6587\u5b57\u30a2\u30eb\u30d5\u30a1\u30d9\u30c3\u30c8",
    "Upper Roman": "\u5927\u6587\u5b57\u30ed\u30fc\u30de\u5b57",
    "Url": "URL",
    "User Defined": "\u30e6\u30fc\u30b6\u30fc\u5b9a\u7fa9",
    "Valid": "\u6709\u52b9",
    "Version": "\u30d0\u30fc\u30b8\u30e7\u30f3",
    "Vertical align": "\u5782\u76f4\u306b\u6574\u5217",
    "Vertical space": "\u4e0a\u4e0b\u4f59\u767d",
    "View": "\u8868\u793a",
    "Visual aids": "\u8868\u306e\u67a0\u7dda\u3092\u70b9\u7dda\u3067\u8868\u793a",
    "Warn": "\u8b66\u544a",
    "White": "\u30db\u30ef\u30a4\u30c8",
    "Width": "\u5e45",
    "Word count": "\u6587\u5b57\u6570\u30ab\u30a6\u30f3\u30c8",
    "Words": "\u5358\u8a9e\u6570",
    "Words: {0}": "\u5358\u8a9e\u6570\uff1a{0}",
    "Yellow": "\u30a4\u30a8\u30ed\u30fc",
    "Yes": "\u306f\u3044",
    "You are using {0}": "{0}\u3092\u4f7f\u7528\u4e2d",
    "You have unsaved changes are you sure you want to navigate away?": "\u307e\u3060\u4fdd\u5b58\u3057\u3066\u3044\u306a\u3044\u5909\u66f4\u304c\u3042\u308a\u307e\u3059\u3002\u3053\u306e\u30da\u30fc\u30b8\u3092\u96e2\u308c\u307e\u3059\u304b\uff1f",
    "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "\u304a\u4f7f\u3044\u306e\u30d6\u30e9\u30a6\u30b6\u3067\u306f\u30af\u30ea\u30c3\u30d7\u30dc\u30fc\u30c9\u6a5f\u80fd\u3092\u5229\u7528\u3059\u308b\u3053\u3068\u304c\u3067\u304d\u307e\u305b\u3093\u3002\u30ad\u30fc\u30dc\u30fc\u30c9\u306e\u30b7\u30e7\u30fc\u30c8\u30ab\u30c3\u30c8\uff08Ctrl+X, Ctrl+C, Ctrl+V\uff09\u3092\u4f7f\u7528\u3057\u3066\u304f\u3060\u3055\u3044\u3002",
    "alignment": "\u914d\u7f6e",
    "austral sign": "\u30a2\u30a6\u30b9\u30c8\u30e9\u30eb\u8a18\u53f7",
    "cedi sign": "\u30bb\u30c7\u30a3\u8a18\u53f7",
    "colon sign": "\u30b3\u30ed\u30f3\u8a18\u53f7",
    "cruzeiro sign": "\u30af\u30eb\u30bc\u30a4\u30ed\u8a18\u53f7",
    "currency sign": "\u901a\u8ca8\u8a18\u53f7",
    "dollar sign": "\u30c9\u30eb\u8a18\u53f7",
    "dong sign": "\u30c9\u30f3\u8a18\u53f7",
    "drachma sign": "\u30c9\u30e9\u30af\u30de\u8a18\u53f7",
    "euro-currency sign": "\u30e6\u30fc\u30ed\u8a18\u53f7",
    "example": "\u4f8b",
    "formatting": "\u66f8\u5f0f",
    "french franc sign": "\u30d5\u30e9\u30f3\u30b9\u30d5\u30e9\u30f3\u8a18\u53f7",
    "german penny symbol": "\u30c9\u30a4\u30c4\u30da\u30cb\u30fc\u8a18\u53f7",
    "guarani sign": "\u30ac\u30e9\u30cb\u8a18\u53f7",
    "history": "\u5c65\u6b74",
    "hryvnia sign": "\u30d5\u30ea\u30f4\u30cb\u30e3\u8a18\u53f7",
    "indentation": "\u30a4\u30f3\u30c7\u30f3\u30c8",
    "indian rupee sign": "\u30a4\u30f3\u30c9\u30eb\u30d4\u30fc\u8a18\u53f7",
    "kip sign": "\u30ad\u30fc\u30d7\u8a18\u53f7",
    "lira sign": "\u30ea\u30e9\u8a18\u53f7",
    "livre tournois sign": "\u30c8\u30a5\u30fc\u30eb\u30dd\u30f3\u30c9\u8a18\u53f7",
    "manat sign": "\u30de\u30ca\u30c8\u8a18\u53f7",
    "mill sign": "\u30df\u30eb\u8a18\u53f7",
    "naira sign": "\u30ca\u30a4\u30e9\u8a18\u53f7",
    "new sheqel sign": "\u65b0\u30b7\u30a7\u30b1\u30eb\u8a18\u53f7",
    "nordic mark sign": "\u5317\u6b27\u30de\u30eb\u30af\u8a18\u53f7",
    "peseta sign": "\u30da\u30bb\u30bf\u8a18\u53f7",
    "peso sign": "\u30da\u30bd\u8a18\u53f7",
    "ruble sign": "\u30eb\u30fc\u30d6\u30eb\u8a18\u53f7",
    "rupee sign": "\u30eb\u30d4\u30fc\u8a18\u53f7",
    "spesmilo sign": "\u30b9\u30da\u30b9\u30df\u30fc\u30ed\u8a18\u53f7",
    "styles": "\u30b9\u30bf\u30a4\u30eb",
    "tenge sign": "\u30c6\u30f3\u30b2\u8a18\u53f7",
    "tugrik sign": "\u30c8\u30a5\u30b0\u30eb\u30b0\u8a18\u53f7",
    "turkish lira sign": "\u30c8\u30eb\u30b3\u30ea\u30e9\u8a18\u53f7",
    "won sign": "\u30a6\u30a9\u30f3\u8a18\u53f7",
    "yen character": "\u5186\u8a18\u53f7",
    "yen/yuan character variant one": "\u5186/\u5143\u8a18\u53f7\u306e\u30d0\u30ea\u30a8\u30fc\u30b7\u30e7\u30f3",
    "yuan character": "\u4eba\u6c11\u5143\u8a18\u53f7",
    "yuan character, in hong kong and taiwan": "\u9999\u6e2f\u304a\u3088\u3073\u53f0\u6e7e\u306b\u304a\u3051\u308b\u5143\u8a18\u53f7",
    "{0} characters": "{0}\u6587\u5b57",
    "{0} columns, {1} rows": "{0} \u5217\u3001{1} \u884c",
    "{0} words": "{0}\u8a9e"
});